/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Insert_Event_BelowInputs */



/**
* | output |
* | --- |
* | "Insert new event below the selected event" |
*
* @param {Shortcut_Keys_Desc_Insert_Event_BelowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_insert_event_below = /** @type {((inputs?: Shortcut_Keys_Desc_Insert_Event_BelowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Insert_Event_BelowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer un nouvel evenement sous l'evenement selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fügen Sie unterhalb des ausgewählten Ereignisses ein neues Ereignis ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci un nuovo evento sotto l'evento selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставьте новое событие ниже выбранного события.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar nuevo evento debajo del evento seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在选定事件下方插入新事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントの下に新しいイベントを挿入します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट के नीचे नया इवेंट डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira um novo evento abaixo do evento selecionado.")
	return /** @type {LocalizedString} */ ("Insert new event below the selected event")
});